
import api from '@/api';
import { IMensagemSyngoo } from '@/interfaces/mensagens_syngoo';
import { mainStore, retencaoFinanceiraStore } from '@/store';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class SendMessageSyngoo extends Vue {
  @Prop({
    type: Array,
    default: () => [],
  })
  readonly propTitulos;
  //   @Prop({ type: Number }) readonly propId;
  @Prop({ type: String }) readonly propUnidade;
  @Prop({ type: String }) readonly propTitle;
  @Prop({ type: Number }) readonly propC014_id_unidade;
  @Prop({ type: String }) readonly propTitleBtn;
  @Prop({ type: String }) readonly propDias;
  @Prop({ type: String }) readonly propTituloAlert;
  @Prop({ type: Number, default: 0 }) readonly propState;

  public isLoading = false;
  public isLoadingSubmit = false;
  public codigo_barras = '';

  public companyItems = [];
  public tipoSolicitacoes = [];
  public franqueados_telefones = [];
  public tipoAux = 0;
  public statusAux = 0;
  public clicouSalvar = false;
  public created_by_id = 0;
  public created_by_name = '';
  public franchising_id = 0;

  public c014ItemsPessoa = 0;
  public titulo = '';

  public descricao = '';
  public tipoSolicitacao = '';

  public headersFinanceiro = [
    {
      text: 'Nº Título',
      sortable: true,
      value: 'Documento',
      align: 'left',
    },
    {
      text: 'Vencimento',
      sortable: true,
      value: 'T014_Vencimento',
      align: 'left',
    },
    // {
    //   text: "Data pagamento",
    //   sortable: true,
    //   value: "T014_DataPagamento",
    //   align: "left",
    // },
    {
      text: 'Nome / Razão Social',
      sortable: true,
      value: 'NomeRazaoSocial',
      align: 'left',
    },
    {
      text: 'Tipo / Documento',
      sortable: true,
      value: 'TipoPessoa',
      align: 'left',
    },
    {
      text: 'Tipo',
      sortable: true,
      value: 'Tipo',
      align: 'left',
    },
    {
      text: 'Filial',
      sortable: true,
      value: 'Filial',
      align: 'left',
    },
    {
      text: 'Valor original',
      sortable: true,
      value: 'valor_original',
      align: 'left',
    },
    {
      text: 'Valor atualizado',
      sortable: true,
      value: 'valor_atualizado',
      align: 'left',
    },
  ];

  get currentUser() {
    return mainStore.userProfile;
  }

  get allItemsUnidades() {
    let item = this.companyItems[1];
    return item;
  }
  public titleCase(txt: string) {
    return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase();
  }

  public async handleSubmitTitulos() {
    this.$swal({
      title: 'Confirma o envio do boleto para o(s) franqueado(s)?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sim, eu confirmo!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        this.isLoadingSubmit = true;
        this.clicouSalvar = true;

        let res: any = [];

        // Envia mensagem com o boleto e código de barras para cada franqueado da unidade.
        this.franqueados_telefones[1].forEach(async (item) => {
          let mensagem_syngoo: IMensagemSyngoo = {
            c014_id: this.propTitulos[0].c014_id,
            unidade: this.propUnidade,
            franqueado: item.franqueado_nome,
            telefone: item.franqueado_telefone,
            codigo_barra: this.codigo_barras,
            t022_id: this.propTitulos[0].T022_Id,
            documento: this.propTitulos[0].Documento,
            id_parcela: this.propTitulos[0].T014_Id_Parcela,
            data_vencimento: this.propTitulos[0].T014_Vencimento,
            valor_original: this.propTitulos[0].valor_original,
            tipo_aviso: Number(this.propDias),
            created_by_id: this.currentUser.id,
            created_by_name: this.currentUser.full_name,
          };
          res = await retencaoFinanceiraStore.sendMessageSyngoo(mensagem_syngoo);
        });

        if (res) {
          this.$swal.fire('Mensagem enviada para o whatsapp do franqueado.', 'Envio realizado com sucesso!', 'success');
          let response = setTimeout(async () => {
            this.$emit('getPropState', Math.floor(Math.random() * 200));
          }, 1000);
        } else {
          this.$swal.fire('Falha ao enviar a mensagem.', 'Tente novamente mais tarde!', 'error');
        }
      }

      this.isLoadingSubmit = false;
    });
  }

  public async mounted() {
    this.isLoading = true;
    this.clicouSalvar = false;
    this.franqueados_telefones = await retencaoFinanceiraStore.getFranqueadosUnidadeSendMessage(
      this.propC014_id_unidade
    );

    const response = await api.getCodigoBoleto(mainStore.token, this.propTitulos[0].T022_Id);
    if (response) {
      this.codigo_barras = response.data;
    }
    this.isLoading = false;
  }
}
